import EditTierButton from './EditTierButton';
import EditTierButtonContainer from './EditTierButton.container';
export default EditTierButtonContainer(EditTierButton);
